<template>
  <div v-if="item" @click="goBack(item)" class="itemBox">
    <div class="title">
      <!-- <van-tag style="margin-right:5px" v-if="isNewPlate(item.createtime)" color="#7232dd"
        >新</van-tag
      > -->
      <img
        v-if="type == 2 && isNewPlate(item.createtime)"
        class="newIcon"
        src="../../assets/img/newIcon.png"
        alt=""
      />
      <van-tag style="border:0.3px solid #7948EA" v-if="item.type == 1" color="#D43030">买</van-tag>
      <van-tag
        style="border:0.3px solid #7948EA"
        v-if="item.type == 2 || item.type == 0"
        color="#2A82E4"
        >卖</van-tag
      >
      <van-tag style="border:0.3px solid #7948EA" v-if="item.type == 4" color="#FF8D1A">成</van-tag>
      <van-tag
        style="margin-left:4px;border:0.3px solid #b88ffc"
        v-if="item.prop && item.prop == 14"
        color="#b88ffc"
        >[大救生圈]</van-tag
      >
      <van-tag
        style="border:0.3px solid #b88ffc;margin-left:4px"
        v-if="item.prop && item.prop == 13"
        color="#b88ffc"
        >[救生圈]</van-tag
      >
      <!-- <van-tag style="margin-left:4px" color="#b88ffc">[救生圈]</van-tag> -->
      <!-- <van-tag v-if="Number(item.replycount) > 14" style="margin-left:10px;" type="danger"
        >热</van-tag
      > -->
      <span :style="{ color: item.color }" class="custom-title">{{
        item.title || '标题暂未找到'
      }}</span>

      <div @click.stop="item.subscribe ? cancelSubscribe(item) : setSubscribe(item)" class="follow">
        <van-icon v-if="item.subscribe" color="#FF8D1A" name="star" />
        <van-icon color="#FF5733" v-else name="star-o" />
      </div>
    </div>
    <!-- <div class="title">
          <span style="color:#969799;margin-top:10px;font-size:12px" class="custom-title"
            >作者：{{ item.author }}</span
          >
        </div> -->
    <div class="desc">
      <span style="flex:2.5;" class="custom-titl"
        ><img src="../../assets/img/txUserIcon.png" alt="" />{{ (item.author) }}</span
      >
      <span style="flex:2;" class="custom-titl"
        ><img src="../../assets/img/dateIcon.png" alt="" />{{
          formatDateTimeMM(item.lastupdatetime)
        }}
      </span>
      <span style="flex:1.5;" class="custom-titl"
        ><img src="../../assets//img/browseIcon.png" alt="" />{{ item.replycount }}/{{
          item.browsecount
        }}</span
      >
    </div>
    <!-- <div class="desc"> -->
    <!-- <span class="custom-titl">作者：{{ item.author }}</span> -->
    <!-- <span class="custom-titl">{{ getTimeShow(item.lastupdatetime) }}</span> -->
    <!-- <span class="custom-titl">浏览：{{ item.browsecount }}</span>
      <span class="custom-titl">回复：{{ item.replycount }}</span> -->
    <!-- </div> -->
  </div>
</template>
<script>
import { getTimeShow, isNewPlate, formatDateTimeMM, replaceStr } from '@/utils/index';
import { subscribe, cancelSubscribe } from '@/api/base';
export default {
  props: ['item', 'type'],
  methods: {
    getTimeShow,
    isNewPlate,
    formatDateTimeMM,
    replaceStr,
    goBack(item) {
      if (this.type == 2) {
        this.$router.push({
          path: '/postView',
          query: {
            href: encodeURIComponent(encodeURIComponent(item.url)),
            section: item.section,
            title: item.title,
            type: item.type,
            author: item.author,
            date: item.lastupdatetime,
          },
        });
        return;
      }
      this.$router.push({
        path: '/postView',
        query: {
          href: encodeURIComponent(encodeURIComponent(item.url)),
          section: item.section,
          title: item.title,
          type: item.type,
          author: item.author,
          date: item.lastupdatetime,
        },
      });
      return;
      // 判断机型 ios/安卓
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      const el = isiOS ? document.documentElement : document.body;

      this.$route.meta.scrollHeight = el.scrollTop || el.scrollHeight;
      if (isiOS) {
        window.location.href = `${item.url}`;
      } else {
        this.$router.push({
          path: '/posts',
          query: {
            title: item.title,
            src: item.url,
            type: item.type,
            author: item.author,
            date: item.lastupdatetime,
          },
        });
      }
      // this.$router.push({
      //   path: '/posts',
      //   query: { title: item.title, src: item.lasturl },
      // });
      // window.location.href = `${item.lasturl}`;
    },
    setSubscribe(item) {
      subscribe({ postId: item.id || item.postId }).then(res => {
        this.$toast('关注成功');
        item.subscribe = true;
      });
    },
    cancelSubscribe(item) {
      this.$dialog
        .confirm({
          title: '',
          message: '是否取消关注',
        })
        .then(() => {
          // on confirm
          cancelSubscribe({ postId: item.id || item.postId }).then(res => {
            this.$toast('已取消关注');
            item.subscribe = false;
            this.$emit('cancelSubscribe');
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="less" scoped>
.itemBox {
  background: #fff;
  margin-top: 10px;
  padding: 10px;
  box-shadow: 0px 0px 25.5px rgba(242, 245, 233, 1);
  .newIcon {
    display: block;
    width: 13px;
    height: 20px;
    margin-right: 8px;
  }
}
.itemBox .title {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 16px;
  padding-right: 40px;
}
.itemBox .follow {
  position: absolute;
  display: block;
  right: 0px;
  top: -10px;
  padding: 10px;
}
.itemBox .custom-title {
  margin-left: 10px;
  white-space: nowrap; /* 规定文本是否折行 */
  overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
  flex: 1;
}
.itemBox .desc {
  margin-top: 5px;
  display: flex;
  color: #808080;
  font-size: 12px;
  justify-content: space-around;
}
.itemBox .desc:first-child {
  margin-top: 10px;
}
.desc .custom-titl {
  flex: 1;
  display: flex;
  white-space: nowrap; /* 规定文本是否折行 */
  overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
  img {
    display: block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
}
</style>
